import { Button, theme, useSnackbar } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  useDeleteTemplate,
  useGetTemplates,
} from "../../../api/useCalendarTemplateQueries";
import { useUserHasRole } from "../../../hooks/userHooks";

export const Templates = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const isPsychologist = useUserHasRole("Psychologist");
  const { data, isLoading } = useGetTemplates({ enabled: isPsychologist });
  const { mutate: deleteTemplate, isPending: isDeleting } = useDeleteTemplate();

  const hasTemplates = !!data?.templates.length;

  return (
    <Box sx={{ marginTop: "24px" }}>
      <Typography variant="h3">{"Templates"}</Typography>
      {isLoading && (
        <Typography variant="body" color="DARK_GREY">
          {t("LOADING")}
        </Typography>
      )}
      {hasTemplates ? (
        data?.templates?.map((template) => (
          <Box
            key={template.id}
            data-testid={template.name}
            sx={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
          >
            <Typography variant="body-small" sx={{ flex: 1 }}>
              {template.name}
            </Typography>
            <Button
              onClick={() => {
                deleteTemplate(template.id);
                enqueueSnackbar({
                  text: t("CALENDAR_WEEK_TEMPLATES_TEMPLATE_DELETED_SUCCESS"),
                });
              }}
              variant="secondary"
              disabled={isDeleting}
            >
              {t("DELETE")}
            </Button>
          </Box>
        ))
      ) : (
        <Typography
          variant="body"
          sx={{ color: "DARK_GREY", marginTop: theme.MARGIN.MD }}
        >
          {t("CALENDAR_WEEK_TEMPLATES_TEMPLATES_SECTION_NO_TEMPLATES")}
        </Typography>
      )}
    </Box>
  );
};
